import { render } from "./indexPlan.vue?vue&type=template&id=4c3464d6"
import script from "./indexPlan.vue?vue&type=script&lang=js"
export * from "./indexPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__